import UserActions from "lib/userActions";
import I18n from "lib/i18n/i18n";
import _ from "lodash";

const getAppHashVersion = () => {
    if (typeof REACT_APP_GIT_HASH !== "undefined") {
        return REACT_APP_GIT_HASH;
    }
};

const EVENTS = {
    names: {
        interaction: "interaction",
        data: "pushData",
        feedback: "feedback",
    },
    actions: {
        open: "open",
        click: "click",
        success: "success",
        select: "select",
        input: "input",
        navigate: "navigate",
        clear: "clear",
        toggle: "toggle",
        failure: "failure",
        close: "close",
        submit: "submit",
    },
};
export default class sendEvents {
    static supportNegotiationEvent(id, event, value) {
        UserActions.supportNegotiation(
            "support_negotiation",
            I18n.getString("itemPage::supportNegotiation::version"),
            id,
            event,
            value
        );
    }
}

const removeUndefined = (obj) => {
    // eslint-disable-next-line no-param-reassign
    Object.keys(obj).forEach((key) =>
        [null, undefined].includes(obj[key]) ? delete obj[key] : {}
    );
    return obj;
};

export class BaseEvent {
    static dataObject = {};

    static pushToDataLayer = (data) => {
        if (_.isEmpty(data)) return;

        if (!window.dataLayer) return;
        window.dataLayer.push(data);
    };

    static setToDataObject = (obj) => {
        this.dataObject = {
            ...this.dataObject,
            ...(obj || {}),
        };
    };

    static checkDataObj = (keys) => {
        return _.isEqual(
            _.intersection(_.keys(this.dataObject), keys).length,
            keys.length
        );
    };

    static locationObject = (location) => {
        return {
            location1: location[0] || null,
            location2: location[1] || null,
            location3: location[2] || null,
            location4: location[3] || null,
            location5: location[4] || null,
        };
    };

    static eventObject = (params) => ({
        event: params.event,
        action: params.action || null,
        actionedObject: params.actionedObject || null,
        actionedValue: params.actionedValue || null,
        actionedObject2: params.actionedObject2 || null,
        actionedValue2: params.actionedValue2 || null,
        actionedObject3: params.actionedObject3 || null,
        actionedValue3: params.actionedValue3 || null,
        actionedObject4: params.actionedObject4 || null,
        actionedValue4: params.actionedValue4 || null,
        actionedObject5: params.actionedObject5 || null,
        actionedValue5: params.actionedValue5 || null,
        fieldName: params.fieldName || null,
        fieldValue: params.fieldValue || null,
        topic: params.topic || null,
        appVersion: getAppHashVersion() || null,
        ...this.locationObject(params.location || []),
    });

    static dataEventObject = (data) =>
        removeUndefined({
            ...data,
            event: EVENTS.names.data,
            appVersion: getAppHashVersion() || null,
        });

    static data(data) {
        this.setToDataObject(removeUndefined(data));
        this.pushToDataLayer(this.dataEventObject(data));
    }

    static open({
        location,
        actionedObject,
        actionedValue,
        actionedObject2,
        actionedValue2,
        actionedObject3,
        actionedValue3,
    }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.feedback,
                action: EVENTS.actions.open,
                location,
                actionedObject,
                actionedValue,
                actionedObject2,
                actionedValue2,
                actionedObject3,
                actionedValue3,
            })
        );
    }

    static close({ location }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.feedback,
                action: EVENTS.actions.close,
                location,
            })
        );
    }

    static click({ location, actionedObject, actionedValue }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.interaction,
                action: EVENTS.actions.click,
                location,
                actionedObject,
                actionedValue,
            })
        );
    }

    static success({
        location,
        actionedObject,
        actionedValue,
        actionedObject2,
        actionedValue2,
        actionedObject3,
        actionedValue3,
        actionedObject4,
        actionedValue4,
    }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.feedback,
                action: EVENTS.actions.success,
                location,
                actionedObject,
                actionedValue,
                actionedObject2,
                actionedValue2,
                actionedObject3,
                actionedValue3,
                actionedObject4,
                actionedValue4,
            })
        );
    }

    static submit({ location, actionedObject, fieldName, fieldValue }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.interaction,
                action: EVENTS.actions.submit,
                location,
                actionedObject,
                fieldName,
                fieldValue,
            })
        );
    }

    static select({
        location,
        actionedObject,
        actionedValue,
        actionedObject2,
        actionedValue2,
        actionedObject3,
        actionedValue3,
        fieldName,
        fieldValue,
    }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.interaction,
                action: EVENTS.actions.select,
                location,
                actionedObject,
                actionedValue,
                actionedObject2,
                actionedValue2,
                actionedObject3,
                actionedValue3,
                fieldName,
                fieldValue,
            })
        );
    }

    static navigate({
        location,
        actionedObject,
        actionedValue,
        actionedObject2,
        actionedValue2,
        actionedObject3,
        actionedValue3,
    }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.interaction,
                action: EVENTS.actions.navigate,
                location,
                actionedObject,
                actionedValue,
                actionedObject2,
                actionedValue2,
                actionedObject3,
                actionedValue3,
            })
        );
    }

    static input({
        location,
        actionedObject,
        actionedValue,
        actionedObject2,
        actionedValue2,
        actionedObject3,
        actionedValue3,
        fieldName,
        fieldValue,
    }) {
        this.pushToDataLayer(
            this.eventObject({
                event: EVENTS.names.interaction,
                action: EVENTS.actions.input,
                location,
                actionedObject,
                actionedValue,
                actionedObject2,
                actionedValue2,
                actionedObject3,
                actionedValue3,
                fieldName,
                fieldValue,
            })
        );
    }
}
